
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/form-helper-text",
      function () {
        return require("private-next-pages/material-ui/api/form-helper-text.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/form-helper-text"])
      });
    }
  